import { makeAutoObservable, runInAction } from 'mobx';
import { action } from 'mobx';

export class StyleState {
	classNames: string;
    rawCss?: React.CSSProperties;
	children?: Map<string, StyleState>;

	constructor(initialClassNames?: string, initialChildren?: Map<string, StyleState>, initialCss?: Record<string, string>) {
		makeAutoObservable(this);

		this.classNames = initialClassNames ? initialClassNames : '';
		if (initialChildren) {
			this.children = initialChildren;
		}
        this.rawCss = initialCss ? initialCss : {};
	}

	addClass = action((target: string) => {
		const trimmedTarget = target.replaceAll(' ', '');
		const regex = new RegExp('(^| )' + trimmedTarget + '($| )', 'g');
		if (!this.classNames.match(regex)) {
			this.classNames += ' ' + trimmedTarget;
		}
	}); // addClass()

	removeClass = action((target: string) => {
		const trimmedTarget = target.replaceAll(' ', '');
		const regex = new RegExp('(^| )' + trimmedTarget + '($| )', 'g');
		this.classNames = this.classNames.replaceAll(regex, '');
	}); // removeClass()

	get(path: string): StyleState {
		const pathParts = path.split('.');
		return this._navigate(pathParts);
	}
	_navigate(pathParts: string[]): StyleState {
		if (!this.children) {
			return this;
		}
		if (pathParts.length === 1) {
			const child = this.children.get(pathParts[0]);
			if (child) {
				return child;
			}
			return this;
		}
		const child = this.children.get(pathParts[0]);
		if (child) {
			return child._navigate(pathParts.slice(1));
		}
		return this;
	} // _navigate()
} // class StyleState

export const initialStyleState = runInAction(() => {return new StyleState(
	undefined,
	new Map<string, StyleState>([
        ['app-wide', new StyleState('dark-mode')],
        ['navigation', new StyleState(
            undefined,
            new Map<string, StyleState>([
                ['nav-menu', new StyleState('navigationMenu flex-mother-col')],
                ['nb-burger', new StyleState('navbarButton hidden')]
            ])
        )],
        ['dropzone', new StyleState('dropzone hidden')],
        ['email-table', new StyleState(
            undefined,
            new Map<string, StyleState>([
                ['from', new StyleState(undefined, undefined, {width: '300px'})],
                ['to', new StyleState(undefined, undefined, {width: '150px'})],
                ['date', new StyleState(undefined, undefined, {width: '125px'})],
                ['size', new StyleState(undefined, undefined, {width: '100px'})]
            ])
        )],
        ['message-info', new StyleState(
            undefined,
            new Map<string, StyleState>([
                ['menu', new StyleState('messageInfoMenu flex-mother-col messageInfo-1')],
                ['raiseButton', new StyleState('navbarButton-half')],
                ['lowerButton', new StyleState('navbarButton-half')]
            ])
        )],
    ])
);});

export const toggleNavigationMenu = action(function (styles: StyleState) {
    const currentNavMode = styles.get('navigation.nav-menu');
    if(currentNavMode.classNames.includes('navigation-hidden')) {
        currentNavMode.removeClass('navigation-hidden');
        styles.get('navigation.nb-burger').addClass('hidden');
    } else {
        currentNavMode.addClass('navigation-hidden');
        styles.get('navigation.nb-burger').removeClass('hidden');
    }
}); // toggleNavigationMenu()

export const raiseMessageInfoMenu = action(function (styles: StyleState) {
    const currentMimMode = styles.get('message-info.menu');
    if(currentMimMode.classNames.includes('messageInfo-0')) {
        currentMimMode.removeClass('messageInfo-0');
        currentMimMode.addClass('messageInfo-1');
        styles.get('message-info.lowerButton').removeClass('hidden');
    } else { // messageInfo-1
        currentMimMode.removeClass('messageInfo-1');
        styles.get('message-info.raiseButton').addClass('hidden');
    }
}); // raiseMessageInfoMenu()

export const lowerMessageInfoMenu = action(function (styles: StyleState) {
    const currentMimMode = styles.get('message-info.menu');
    if(currentMimMode.classNames.includes('messageInfo-1')) {
        currentMimMode.removeClass('messageInfo-1');
        currentMimMode.addClass('messageInfo-0');
        styles.get('message-info.lowerButton').addClass('hidden');
    } else { // fully raised
        currentMimMode.addClass('messageInfo-1');
        styles.get('message-info.raiseButton').removeClass('hidden');
    }
}); // lowerMessageInfoMenu()